import type { WebchatTranslations } from '.'

export const ko: WebchatTranslations = {
  'composer.placeholder': '메시지를 입력하세요...',
  'composer.sendButton.ariaLabel': '메시지 보내기 버튼',
  'composer.voiceButton.ariaLabel': '음성 입력 버튼',
  'composer.fileButton.ariaLabel': '파일 업로드 버튼',
  'composer.messageInput.ariaLabel': '메시지 입력',

  'fileAttachment.uploadError': '업로드 오류',
  'fileAttachment.fallbackExtension': '파일',
  'fileAttachment.removeButton.ariaLabel': '파일 삭제 버튼',

  'header.defaultBotName': '봇',
  'header.expandButton.ariaLabel': '헤더 펼치기 버튼',
  'header.sound.enable': '채팅 소리 켜기',
  'header.sound.disable': '채팅 소리 끄기',

  'conversationHistory.title': '대화 목록',
  'conversationHistory.empty': '아직 시작된 대화가 없습니다',
  'conversationHistory.newConversation': '새 대화',
  'conversationHistory.sentAttachment': '첨부 파일을 보냈습니다',
  'conversationHistory.showButton.ariaLabel': '최근 대화 보기 버튼',

  'restartConversation.title': '새 대화 만들기',
  'restartConversation.description': '현재 대화를 지우고 새 대화를 시작합니다.',
  'restartConversation.confirm': '새 대화',
  'restartConversation.cancel': '취소',
  'restartConversation.button.ariaLabel': '대화 다시 시작 버튼',

  'closeButton.ariaLabel': '챗봇 닫기 버튼',

  'feedback.title': '개선에 도움을 주세요',
  'feedback.description': '서비스 개선을 위해 피드백을 보내주세요.',
  'feedback.confirm': '피드백 보내기',
  'feedback.cancel': '취소',
  'feedback.placeholder': '어떤 점이 문제였는지 알려주세요...',

  'error.configuration': '설정 오류',
  'error.bot': '봇 오류',
  'error.network': '네트워크 오류',
  'error.disconnected': '연결 끊김',
  'error.unexpected': '예기치 않은 오류',

  'dropdown.placeholder': '선택...',

  'message.status.delivered': '전달됨',

  'date.today': '오늘',
  'date.yesterday': '어제',
}
